import Header from "./components/Header";
import Main from "./components/Main";
import TextArea from "./components/TextArea";

function App() {
  return (
    <div>
      <Header />
      <TextArea />
      <Main />
    </div>
  );
}

export default App;
